<template>
	<div :id="['home']">
		<h1 ref="mainTitle"><span>Thomas Boulongne</span><span>Front-end developer</span></h1>
		<router-link to="about" class="about-link" ref="aboutLink">
			<div @mouseenter="titleEnter" @mouseleave="titleLeave"><span>About</span></div>
		</router-link>
		<div class="projects" ref="projectsWrapper" style="transform:translateY(100vh)">
			<project-comp v-for="(project, i) in projects" :key="project.sys.id" :fields="project.fields" ref="projects" :centered="currentProject === i ? true : false"></project-comp>
		</div>
	</div>
</template>
<script>
import ProjectComp from './Project'
import throttle from 'lodash/throttle'
export default {
	data() {
		return {
			mousePosition: {
				x: 0,
				y: 0
			},
			canAnimate: false,
			throttledScrollPosition: throttle(function() {
				this.checkProjectsPosition()
			}, 100),
			projectsBounds: [],
			currentProject: -1
		}
	},
	computed: {
		loaded: function() {
			return this.$store.getters['ui/isContentLoaded'];
		},
		page: function() {
			return this.$store.getters['pages/page']('home')
		},
		projects: function() {
			return this.$store.getters['projects/list'].filter(project => project.fields.video)
		},
		scrollPosition: function() {
			return this.$store.getters['ui/scrollPosition']
		},
		viewportSize: function() {
			return this.$store.getters['ui/viewportSize']
		}
	},
	watch: {
		scrollPosition: function() {
			this.throttledScrollPosition()
		},
		viewportSize: function() {
			setTimeout(() => {
				this.updateProjectsBounds()
			}, 200)
		},
		projects: function() {
			this.$nextTick(this.updateProjectsBounds)
		}
	},
	mounted() {
		this.updateProjectsBounds()
	},
	methods: {
		updateProjectsBounds() {
			if (this.$refs.projects) {
				const projectsBounds = []
				const wrapperTop = this.$el.getBoundingClientRect().top > 0 ? this.$el.getBoundingClientRect().top : 0
				const height = this.$refs.projects[0].$el.getBoundingClientRect().height
				let top = 0
				for (let index = 0; index < this.projects.length; index++) {
					top = index * height
					projectsBounds.push(top)
				}
				this.projectsBounds = projectsBounds
			}
		},
		showTimeline() {
			this.updateProjectsBounds()
			return new Promise(resolve => {
				const tl = new TimelineMax({
					onComplete: () => {
						resolve()
					}
				})
				this.$refs.projects.forEach((project, i) => {
					tl
					.fromTo(project.$el, 1, {
						yPercent: 300 * i
					}, {
						yPercent: 0,
						ease: Power4.easeOut,
						onComplete: () => {
							TweenMax.set(project.$el, {
								clearProps: 'transform'
							})
						}
					}, 0)
				})
				tl
				.to(this.$refs.projectsWrapper, 1, {
					y: 0,
					ease: Power4.easeOut,
					onComplete: () => {
						TweenMax
						.set(this.$refs.projectsWrapper, {
							clearProps: 'all'
						})
					}
				}, 0)
				.add(() => {
					this.canAnimate = true
					this.checkProjectsPosition()
				}, '-=0.5')
				.add(() => {
					this.$store.dispatch('ui/unblockOverflow')
				})
				.to(this.$refs.aboutLink.$el, 1.2, {
					'--clip-x': 100,
					ease: Power4.easeOut
				}, '+= 0.2')
				.to(this.$refs.mainTitle, 1.2, {
					'--clip-x': 100,
					ease: Power4.easeOut
				}, '-= 1')
			})
		},
		checkProjectsPosition() {
			if (this.canAnimate) {
				let centeredIndex = null
				const scroll = this.scrollPosition.y
				for (let index = 0; index < this.projectsBounds.length; index++) {
					const top = this.projectsBounds[index];
					if (scroll >= top) {
						centeredIndex = index
					} else {
						break
					}
				}
				this.currentProject = centeredIndex !== null ? centeredIndex : this.currentProject
			}
		},
		titleEnter() {
			if (this.$refs.aboutLink) {
				const tl = new TimelineMax({paused: true})
				const duration = 2
				tl
				.to(this.$refs.aboutLink.$el, 0.3 * duration, {
					'--title-underline-scale': 1,
					color: '#ffffff',
					overwrite: 'preexisting',
					ease: Power4.easeIn
				})
				.set(this.$refs.aboutLink.$el, {
					'--title-underline-origin': 'top'
				})
				.to(this.$refs.aboutLink.$el, 0.13 * duration, {
					'--title-underline-scale': 0.1,
					color: '#aaaaaa',
					ease: Power4.easeOut
				})
				tl.play()
			}
		},
		titleLeave() {
			if (this.$refs.aboutLink) {
				const tl = new TimelineMax({paused: true})
				const duration = 2
				tl
				.to(this.$refs.aboutLink.$el, 0.2 * duration, {
					'--title-underline-scale': 1,
					color: '#ffffff',
					overwrite: 'preexisting',
					ease: Power4.easeIn
				})
				.set(this.$refs.aboutLink.$el, {
					'--title-underline-origin': 'bottom'
				})
				.to(this.$refs.aboutLink.$el, 0.1 * duration, {
					'--title-underline-scale': 0.1,
					color: '#aaaaaa',
					ease: Power4.easeOut
				})
				tl.play()
			}
		},
		openAbout() {
			const tl = new TimelineMax({
				onStart: () => {
					this.$store.dispatch('ui/blockOverflow')
				}
			})
			const first = this.$refs.projects[this.currentProject].$el
			const second = this.currentProject > 0 ? (this.currentProject < this.$refs.projects.length - 1 ? [this.$refs.projects[this.currentProject - 1].$el, this.$refs.projects[this.currentProject + 1].$el] : this.$refs.projects[this.currentProject - 1].$el) : this.$refs.projects[this.currentProject + 1].$el
			tl
			.to(first, 0.5, {
				x: this.viewportSize.width / 2,
				ease: Power1.easeIn
			}, 0)
			.to(second, 0.5, {
				x: this.viewportSize.width / 2.4,
				ease: Power1.easeIn
			}, 0)
			.to(first, 0.3, {
				opacity: 0.2
			}, 0)
			return tl
		}
	},
	components: {
		ProjectComp
	}
}
</script>
<style lang="sass">
#home
	position: relative
	--padding-x: 1.5em
	--padding-y: 0.35em
	--margin: 2rem
	--image-width: 60vw
	--image-height: calc(var(--image-width) / 1.7)
	--project-offset: calc(100vh/2 - var(--image-height) / 2)
	--clip-x: 0
	.project:first-child
		margin-top: var(--project-offset)
	.project:last-child
		margin-bottom: var(--project-offset)
	h1
		display: block
		font-size: 1rem
		letter-spacing: 0.02em
		position: absolute
		line-height: 1.2
		left: calc(var(--margin) + var(--padding-y))
		top: calc(var(--margin) + var(--padding-y) - var(--project-offset))
		clip-path: polygon(0% calc((100 - var(--clip-x)) * 1%), 100% calc((100 - var(--clip-x)) * 1%), 100% 100%, 0% 100%)
		span:nth-child(2)
			color: var(--grey)
			&:before
				content: '●'
				margin: 0 0.5em
	.about-link
		position: fixed
		margin-left: var(--margin)
		padding: var(--padding-y) var(--padding-x)
		font-size: 1rem
		top: 50%
		transform: rotate(-90deg)
		transform-origin: top left
		font-family: sans-serif
		color: var(--grey)
		display: inline-block
		z-index: 3
		cursor: pointer
		text-decoration: none
		--title-underline-scale: 0.1
		--title-underline-origin: bottom
		clip-path: polygon(0% 0%, calc(var(--clip-x) * 1%) 0%, calc(var(--clip-x) * 1%) 100%, 0% 100%)
		span
			position: relative
		&:before
			content: ''
			position: absolute
			top: 0
			right: var(--padding-x)
			bottom: 0
			left: var(--padding-x)
			background-color: var(--grey)
			transform: scaleY(var(--title-underline-scale))
			transform-origin: var(--title-underline-origin)
</style>



// WEBPACK FOOTER //
// src/components/Home.vue